import React, { Component } from 'react';
import { connect } from 'react-redux';
import CreatePaymentView from './CreatePayment.view';

export class CreatePaymentContainer extends Component {

  constructor(props) {
    super(props);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.closeCreateModal = this.closeCreateModal.bind(this);
    this.addRow = this.addRow.bind(this);
    this.removeRow = this.removeRow.bind(this);
  }

  closeCreateModal() {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_MODAL',
      payload: {
        active: false,
      }
    });
  }

  addRow() {
    const { dispatch } = this.props;
    dispatch({
      type: 'CREATE_FORM_ADD_PAYMENT',
      payload: {},
    });
  }

  removeRow(index) {
    const { dispatch } = this.props;
    dispatch({
      type: 'CREATE_FORM_REMOVE_PAYMENT',
      payload: {
        index,
      },
    });
  }

  onFormUpdate(formState, actions) {
    const { dispatch } = this.props;
    dispatch({
      type: 'ON_PAYMENT_CREATE_FORM_UPDATE',
      payload: {
        formState: {
          ...formState,
          data: {
            ...formState.data,
            payments: (formState.data.payments || []).map(payment => ({
              ...payment,
              code: (payment.code || '').replace(/[-_ ]/g, '').toUpperCase(),
              pin: (payment.pin || '').replace(/[-_ ]/g, '').toUpperCase(),
            }))
          }
        },
      },
    });
  }

  submitForm(formState) {
    const { dispatch, filtersFormState, page } = this.props;
    dispatch({
      type: 'CREATE_PAYMENT',
      payload: {
        data: formState.data,
        filters: filtersFormState.data,
        page: page,
      },
    });
  }

  render() {
    return (<CreatePaymentView
      {...this.state}
      {...this.props}
      closeCreateModal={this.closeCreateModal}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
      addRow={this.addRow}
      removeRow={this.removeRow}
    />);
  }

}

function mapStateToProps(state) {
  const { payments, dynamicData } = state;
  return {
    createModalActive: payments.createModalActive,
    formState: payments.createFormState,
    filtersFormState: payments.filtersFormState,
    page: payments.page,
    buyOffers: payments.buyOffers,
    amazonAccounts: dynamicData.amazonAccounts,
  };
}

export default connect(mapStateToProps)(CreatePaymentContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/CreatePayment/CreatePayment.container.js